import { render } from "./config_io_unit.vue?vue&type=template&id=2f24740c&scoped=true"
import script from "./config_io_unit.vue?vue&type=script&lang=js"
export * from "./config_io_unit.vue?vue&type=script&lang=js"

import "./config_io_unit.vue?vue&type=style&index=0&id=2f24740c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f24740c"]])

export default __exports__